import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleLookup'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleLookupStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleLookupStore",
			variables: false,
		})
	}
}

export async function load_VehicleLookup(params) {
  await initClient()

	const store = new VehicleLookupStore()

	await store.fetch(params)

	return {
		VehicleLookup: store,
	}
}
